import { gql } from '@apollo/react-hooks';

export interface MerchantProductOfferImageUrlsInput {
    defaultSize: string;
}

export interface SaveMerchantProductOfferMutationVariables {
    userSavedMerchantProductOffer: {
        merchantProductOfferId: string;
        originalTitle: string;
        processedWebpageUrl: string;
        mainImageUrls: MerchantProductOfferImageUrlsInput;
        merchantId: string;
    };
}

export interface SaveMerchantProductOfferMutationResponse {
    saveMerchantProductOffer: boolean;
}

export const saveMerchantProductOfferMutation = gql`
    mutation SaveMerchantProductOffer($userSavedMerchantProductOffer: SaveMerchantProductOfferInput!) {
        saveMerchantProductOffer(userSavedMerchantProductOffer: $userSavedMerchantProductOffer)
    }
`;

export interface UnsaveMerchantProductOfferMutationVariables {
    merchantProductOfferId: string;
}

export interface UnsaveMerchantProductOfferMutationResponse {
    unsaveMerchantProductOffer: boolean;
}

export const unsaveMerchantProductOfferMutation = gql`
    mutation UnsaveMerchantProductOffer($merchantProductOfferId: String!) {
        unsaveMerchantProductOffer(merchantProductOfferId: $merchantProductOfferId)
    }
`;
